<template>
    <div class="public">
        <cookie-bar></cookie-bar>

        <SimpleHeader />

        <main>
            <div class="structure">
                <back-to-home />
                <cookie-policy />
                <div class="page-job-code">Job code: {{ $route.meta.jobCode }} | {{ dateOfPrep }}</div>
            </div>
        </main>
    </div>
</template>

<script>
import SimpleHeader from '@/components/layout/SimpleHeader.vue';
import BackToHome from '@/components/layout/BackToHome.vue';
import CookiePolicy from '@/components/legal/CookiePolicy.vue';

export default {
    name: 'PublicCookiePage',
    components: {
        BackToHome,
        SimpleHeader,
        CookiePolicy
    },
    data () {
        return {
            dateOfPrep: 'March 2023'
        };
    }
};
</script>
